export default __webpack_public_path__ + "locales/ar-SA/ChangeUserTypeDialog.json?hash=97e85850089131feaac75f8c5452b464";